import * as React from 'react';
import { DropDownListComponent } from '../DropDownList/DropDownListComponent';
import { ItemList } from '../../types/logbook-type';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useOrganizationList } from '../../data/DataProviders/OrganizationListProvider';
import { useDispatch, useSelector } from 'react-redux';
import { Thunks } from '../../actions';
import { Selectors } from '../../selectors';
import { BuildingList } from '../../types/building';

export interface Props {
    defaultValue: string;
    organizationId?: string | number;
    callback: (organizationId: string) => void;
}

const BuildingFilterSelect: React.FunctionComponent<Props> = (props) => {

    const { defaultValue, callback } = props;
    const dashboard = useSelector(Selectors.Dashboard.dashboard);
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();

    const [records, setRecords] = React.useState<ItemList>([]);

    const handleChange = (organizationId: string) => {
        dispatch(Thunks.Customer.getCustomerListV2(organizationId));
        dispatch(Thunks.Asset.getDeviceList(organizationId, '', '', '', '', '', '', ''));
        callback(organizationId);
    }

    const buildingListData = (list: BuildingList): ItemList => {
        return list?.map((data, building) => {
            return {
                id: data.buildingId,
                name: data.name,
            };
        });
    };

    React.useEffect(() => {
        if (!dashboard.buildingListLoading && dashboard.buildingListSuccess) {
            setRecords(buildingListData(dashboard.buildingList.detail));
        } else if (!dashboard.buildingListLoading && dashboard.buildingListFail) {
            setRecords([]);
        }
    }, [dashboard.buildingListLoading, dashboard.buildingListSuccess, dashboard.buildingListFail]);; //eslint-disable-line react-hooks/exhaustive-deps

    return (
        <DropDownListComponent
            disabled={false}
            data-testid="asset-building-filter"
            list={records}
            value={t('SEARCH.ALL_BUILDINGS')}
            handleSelection={handleChange}
            selected={''}
            defaultSelection={defaultValue}>
        </DropDownListComponent>
    );
};

export default BuildingFilterSelect;
